import React, { useEffect, useState } from 'react';
import {
  Alert, Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Switch,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField,
} from '@mui/material';
import Layout from '../components/Layout';
import { clientAPI } from '../services/api';
import { apiError } from '../utils/format';

const EMPTY = { nom: '', adresse: '', ville: '', telephone: '', email: '', ninea: '', notes: '', is_active: true };
const LABELS = { nom: 'Nom *', adresse: 'Adresse', ville: 'Ville', telephone: 'Téléphone', email: 'Email', ninea: 'NINEA', notes: 'Notes' };

const Clients = () => {
  const [rows, setRows] = useState([]);
  const [edit, setEdit] = useState(null);
  const [error, setError] = useState('');

  const load = () => clientAPI.list(true).then((r) => setRows(r.data)).catch((err) => setError(apiError(err)));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (edit.id) await clientAPI.update(edit.id, edit); else await clientAPI.create(edit);
      setEdit(null); load();
    } catch (err) { setError(apiError(err)); }
  };
  const remove = async (c) => {
    if (!window.confirm(`Supprimer ${c.nom} ?`)) return;
    try { await clientAPI.remove(c.id); load(); } catch (err) { setError(apiError(err)); }
  };

  return (
    <Layout title="Clients">
      {error && <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>{error}</Alert>}
      <Box sx={{ mb: 2 }}><Button variant="contained" onClick={() => setEdit({ ...EMPTY })}>Nouveau client</Button></Box>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Nom</TableCell><TableCell>Adresse</TableCell><TableCell>Ville</TableCell>
              <TableCell>Téléphone</TableCell><TableCell>NINEA</TableCell><TableCell align="right">BL</TableCell>
              <TableCell align="right">Factures</TableCell><TableCell /><TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((c) => (
              <TableRow key={c.id} hover sx={{ opacity: c.is_active ? 1 : 0.5 }}>
                <TableCell><strong>{c.nom}</strong></TableCell><TableCell>{c.adresse}</TableCell><TableCell>{c.ville}</TableCell>
                <TableCell>{c.telephone}</TableCell><TableCell>{c.ninea}</TableCell>
                <TableCell align="right">{c.nb_bl}</TableCell><TableCell align="right">{c.nb_factures}</TableCell>
                <TableCell>{!c.is_active && <Chip size="small" label="Désactivé" />}</TableCell>
                <TableCell align="right">
                  <Button size="small" onClick={() => setEdit({ ...EMPTY, ...Object.fromEntries(Object.entries(c).map(([k, v]) => [k, v ?? ''])) })}>Modifier</Button>
                  {c.nb_bl + c.nb_factures === 0 && <Button size="small" color="error" onClick={() => remove(c)}>Supprimer</Button>}
                </TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && <TableRow><TableCell colSpan={9} align="center">Aucun client</TableCell></TableRow>}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={!!edit} onClose={() => setEdit(null)} maxWidth="sm" fullWidth>
        <DialogTitle>{edit?.id ? 'Modifier le client' : 'Nouveau client'}</DialogTitle>
        <DialogContent sx={{ pt: '12px !important' }}>
          {edit && Object.keys(LABELS).map((k) => (
            <TextField key={k} fullWidth size="small" sx={{ mb: 2 }} label={LABELS[k]} multiline={k === 'notes'}
              value={edit[k]} onChange={(e) => setEdit({ ...edit, [k]: e.target.value })} />
          ))}
          {edit?.id && (
            <FormControlLabel control={<Switch checked={edit.is_active} onChange={(e) => setEdit({ ...edit, is_active: e.target.checked })} />}
              label="Client actif (proposé dans les BL et factures)" />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEdit(null)}>Fermer</Button>
          <Button variant="contained" onClick={save} disabled={!edit?.nom}>Enregistrer</Button>
        </DialogActions>
      </Dialog>
    </Layout>
  );
};

export default Clients;
